<template>
  <div class=''>

    <!-- <el-row class="mt20" style="">
      <el-form :model="certinfo" label-position="left" style="padding-left:15px;" id="certinfo" label-width="150px">
        <el-form-item :label="$t('lin_global.certificateName')">
          {{ certinfo.certificateName}}
        </el-form-item>
        <el-form-item :label="$t('lin_global.createTime')">
          {{ certinfo.createTime}}
        </el-form-item>
        <el-form-item :label="$t('lin_global.zdqds')">
          {{ certinfo.distributorName}}
        </el-form-item>
        <el-form-item :label="$t('lin_global.remark')">
          {{ certinfo.certificateDesc}}
        </el-form-item>
      </el-form>
    </el-row> -->

    <el-row class='gPageBorder  gPdTB' style=''>
      <el-col :span='12'>
        <el-form class='gShowLeftForm' label-position='left' label-width="30%">
          <el-form-item :label="$t('lin_global.certificateName') ">
            {{ certinfo.certificateName}}
          </el-form-item>
        </el-form>
      </el-col>

      <el-col :span='12'>
        <el-form class='gShowRightForm' label-position='left' label-width="30%">
          <el-form-item :label="$t('lin_global.createTime') ">
            {{ certinfo.createTime}}
          </el-form-item>
        </el-form>
      </el-col>

      <el-col :span='12'>
        <el-form class='gShowLeftForm' label-position='left' label-width="30%">
          <el-form-item :label="$t('lin_global.zdqds') ">
            {{ certinfo.distributorName}}
          </el-form-item>
        </el-form>
      </el-col>

      <el-col :span='12'>
        <el-form class='gShowRightForm' label-position='left' label-width="30%">
          <el-form-item :label="$t('lin_global.remark') ">
            {{ certinfo.certificateDesc}}
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    
    <div class="gTopMg gPageBorder">
      <p class='gPTitle'>{{$t('lin_global.xiafalishi')}}</p>
    

      <el-table :data="arrdata" border>
        <el-table-column
          prop="operationTime"
          :label="$t('lin_global.time')">
        </el-table-column>
        <el-table-column
          prop="merchantName"
          :label="$t('lin_global.label_areaid')">
        </el-table-column>
        <el-table-column
          prop="successQuantity"
          :label="$t('lin_global.chenggong')">
        </el-table-column>
        <el-table-column
          prop="failQuantity"
          :label="$t('lin_global.shibai')">
        </el-table-column>
        <el-table-column
          :label="$t('lin_global.ope')">
          <template slot-scope="scope">
            <!-- <el-button v-if="scope.row.operateAgain == '1'" @click.stop="resXiafa(scope.row.id,scope.row.merchantId,scope.row.opearationType,scope.row.pushtype,scope.row.certificateid)" type="text">{{$t('lin_global.resXiafa')}}</el-button> -->
            <el-tooltip class="item" effect="dark" :content="$t('lin_global.resXiafa')" placement="top">
              <el-button type='text'  v-if="scope.row.operateAgain == '1'" @click.stop="resXiafa(scope.row.id,scope.row.merchantId,scope.row.opearationType,scope.row.pushtype,scope.row.certificateid)"><i class="fa fa-trash-o" style="color:#FF4949"></i></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <div class='gPgDiv'>
        <el-pagination
          class='gPg'
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10,50,100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalRecords"
          >
        </el-pagination>
      </div>

    </div>

  </div>
</template>
<script>
  import axios from 'axios'
  import { baseurl } from '../../api/url'
  export default{
    data(){
      return{
        currentPage: 1,
        pageSize: 10,
        totalRecords: 0,
        certinfo:{},
        arrdata:[]
      }
    },
    created(){
      this.getDetail();
      this.getList(1);
    },
    methods:{
      getList:function(page){
        this.currentPage = page;
        var params = {certificateId:this.$route.params.id,page:page,rows:this.pageSize,opflag:'3,4'}
        axios.post(`${baseurl}/authorization/opRecording.do`,params).then(res=>{
            console.log("数据别表");
            console.log(res.data);
          if(res.data.status == 200){
            this.arrdata = res.data.data;
            this.totalRecords = res.data.total;
          }else{
            this.$message.error(res.data.message)
          }

        })
      },
      handleSizeChange: function (val) {
        this.pageSize = val
        this.getList(this.currentPage)
      },
      handleCurrentChange: function (val) {
        this.currentPage = val
        this.getList(this.currentPage)
      },
      resXiafa:function(a,b,c,d,e){
          var params = {
            id:a,
            merchantId:b,
            operationType:c,
            pushType:d,
            certificateId:e
          }
        axios.post(`${baseurl}/authorization/opAgain.do`,params).then(res=>{
          if(res.data.status == 200){
            this.$message.success(res.data.message);
            this.getList(1);
          }else{
            this.$message.error(res.data.message)
          }
        })
      },
      getDetail:function(){
        var certId = this.$route.params.id;
        var params = {certificateId:certId};
        axios.post(`${baseurl}/cer/getById.do`,params).then(res=>{
          console.log(res.data);
          if(res.data.status == 200){
            this.certinfo = res.data.data;
          }
        })
      },
    }
  }
</script>



// WEBPACK FOOTER //
// certDetail.vue?816c810e